import { IMAGE_LOADER, ImageLoaderConfig } from "@angular/common";
import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { DeviceSize, DeviceSizeService } from "@dtm-frontend/shared/ui";
import { UntilDestroy } from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
    selector: "dtm-main-page-lib-where-you-can-fly-banner",
    templateUrl: "./where-you-can-fly-banner.component.html",
    styleUrls: ["./where-you-can-fly-banner.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: IMAGE_LOADER,
            useValue: (config: ImageLoaderConfig) => {
                const fileName = config.src;

                if (!config.width || config.width <= 100) {
                    return fileName;
                }

                return fileName.replace(".png", "@2x.png");
            },
        },
    ],
})
export class WhereYouCanFlyBannerComponent {
    protected readonly isMobile$ = inject(DeviceSizeService).getSizeObservable(
        DeviceSize.Smartphone,
        DeviceSize.SmartphoneWide,
        DeviceSize.Tablet
    );
}
